import { createContext } from 'react';
import { type SubscriptionListRow, type ServiceUser } from '@sr/types/subscription';
import { type ConfirmationOrder, type ConfirmationPartner } from '../Checkout/Confirmation/types';

export type SubscriptionDetails = {
  order: ConfirmationOrder;
  user: ServiceUser;
  purchaser: ServiceUser;
  invoicePartner: ConfirmationPartner;
};

export type SubscriptionsContextValue = {
  subscriptions: SubscriptionListRow[] | null;
  loading: boolean;
  getSubscriptions: () => Promise<SubscriptionListRow[]>;
  getSubscriptionDetailsById: (id: string) => Promise<SubscriptionDetails>;
};

export const SubscriptionsContext = createContext<SubscriptionsContextValue | undefined>(undefined);
